import styles from "./index.css";
import classNames from "classnames";
import logo from "../../images/asosWorldLogoWhiteText.png";
import PropTypes from "prop-types";
import { withTranslation } from "../translation";
import LoyaltyBannerButton from "./Button";

const LoyaltyBanner = ({
  header,
  copy,
  buttonCopy,
  buttonUrl,
  imagePath,
  className,
  formatTranslation
}) => {
  const headerWordsArray = header.split("/").map(text => text.trim());

  return (
    <section className={classNames(styles.loyaltyBanner, className)}>
      <div className={styles.topNoise}></div>
      <div className={styles.leftShoulder}></div>
      <div className={styles.centeredContent}>
        <div className={styles.copyContainer}>
          <img
            alt={formatTranslation("quick_join_overlay_a11y_logo")}
            src={logo}
            className={styles.logo}
          />
          <h2 className={styles.header} aria-label={headerWordsArray.join(" ")}>
            {headerWordsArray.map((text, index) => (
              <span key={index} className={styles.headerLine}>
                {text}
              </span>
            ))}
          </h2>
          <div className={styles.copy}>
            {copy.split("/").map((text, index) => (
              <p key={index}>{text.trim()}</p>
            ))}
          </div>
          <LoyaltyBannerButton copy={buttonCopy} url={buttonUrl} />
        </div>
        <div className={styles.separator}></div>
        <div className={styles.imageContainer}>
          <img
            src={imagePath}
            alt={formatTranslation("quick_join_overlay_a11y_logo")}
          />
        </div>
      </div>
      <div className={styles.rightShoulder}></div>
      <div className={styles.bottomNoise}></div>
    </section>
  );
};

LoyaltyBanner.propTypes = {
  header: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  buttonCopy: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(LoyaltyBanner);
